export default "__VITE_ASSET__ecJoluqL__"